var render = function render(){var _vm=this,_c=_vm._self._c;return _c('normal-table',{ref:"contractTable",staticClass:"contract-detector-list",attrs:{"table-col":_vm.tableCol,"table-data":_vm.list,"first-table-col":_vm.firstTableCol,"operate-col":_vm.operateCol,"operator":_vm.operator,"show-edit":true,"paging":_vm.paging},on:{"pagination":_vm.handleSizeOrPageChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }